import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  HasPlaidAssetReport,
  IsExpressLoan,
  IsExpressPlusLoan,
  RulesetResult,
} from '../rules';

export class BankStatements3MonthRuleset implements Ruleset {
  public evaluate(data: Partial<ApplicationFormValues>): RulesetResult {
    const isExpress = IsExpressLoan.evaluate(data);
    const isExpressPlus = IsExpressPlusLoan.evaluate(data);
    const hasPlaidAssetReport = HasPlaidAssetReport.evaluate(data);

    if (hasPlaidAssetReport) return RulesetResult.OPTIONAL;
    if (isExpress || isExpressPlus) return RulesetResult.HIDDEN;
    return RulesetResult.REQUIRED;
  }
}

export default new BankStatements3MonthRuleset();
